












































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { IBlueprint } from '@/store/types';
import { generateAIReferenceSteps } from '@/helpers/templates';
import { AI_CANCEL_JOB, AI_GENERATE_BLUEPRINT, AI_REWORK_BLUEPRINT, BLUEPRINT_SCHEDULE_SAVE } from '@/store/action-types';
import AIBuildModal from '@/components/UI/AIBuildModal.vue';
import { STORE_BLUEPRINT_DATA } from '@/store/mutation-types';

export default Vue.extend({
  name: 'NewAIBuilder',
  components: {
    AIBuildModal,
  },
  props: {
    blueprintGuid: {
      type: String,
      default: '',
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    onSubmit: {
      type: Function,
      default: () => {
        // do nothing
      },
    },
    generating: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    estimatedCompletionTime: {
      type: Date,
      default: 0,
    },
  },
  data() {
    return {
      showAIBuildModal: false,
      showConfirmCancelAI: false,
      submitted: false,
    };
  },
  computed: {
    ...mapGetters(['provider', 'currentSegment', 'currentBlueprint', 'orgSupportsCoupons', 'aiJobsInProgress']),
    disableButton(): boolean {
      return this.disabled;
    },
    loading(): boolean {
      return this.submitted || this.generating;
    },
    blueprint(): IBlueprint {
      return this.$store.getters.currentBlueprint;
    },
    blueprintIsNew(): boolean {
      return this.blueprint.version === 1;
    },
    timeRemaining(): number {
      // this.estimatedCompletionTime is a date
      const now = new Date();
      const diff = +this.estimatedCompletionTime - now.getTime();
      return Math.round(diff / 1000);
    },
  },
  methods: {
    closeAIBuildModal() {
      this.$data.showAIBuildModal = false;
    },
    async onAISubmit(prompt: string) {
      this.showAIBuildModal = false; // close modal
      this.submitted = true;

      if (this.blueprintIsNew) {
        const steps = generateAIReferenceSteps(); // todo: validate?
        // Start job:
        await this.$store.dispatch(AI_GENERATE_BLUEPRINT, { blueprintGuid: this.blueprintGuid, instructions: prompt, steps });
        /*
        // NOTE: This code below was not a good idea, commenting it out for now. >>>
        // We don't want to alter the local blueprint; just in case the job is canceled or fails!!!
        // So we'll use the AI Reference Template just to submit the generation job. Nothing else.
        // If some steps are disabled and thus don't show the Loading state... we could solve that in other ways.

        // Update blueprint with reference steps so they get enabled and display the loading state:
        this.$store.commit(STORE_BLUEPRINT_DATA, { id: this.blueprint._id, data: { steps } }); // enables steps to show loading animation
        await this.$store.dispatch(BLUEPRINT_SCHEDULE_SAVE, { id: this.blueprint._id, delay: 0 }); // save immediately
        */
      } else {
        await this.$store.dispatch(AI_REWORK_BLUEPRINT, { blueprintGuid: this.blueprintGuid, instructions: prompt, blueprint: this.blueprint });
      }
      this.submitted = false; // no need to force the LOADING state, the AIJob with status=RUNNING takes over now.
    },
    cancelAIJob() {
      this.$store.dispatch(AI_CANCEL_JOB, { blueprintGuid: this.blueprintGuid });
      this.showConfirmCancelAI = false;
    },
  },
});
